














































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import {
  CustomerStatus,
  CustomerType,
  ICustomer,
  ICustomerDeletionImpact,
} from 'admiral-core';
import { XIcon } from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { FormMixin } from '@/mixins/FormMixin';
import { BModal } from 'bootstrap-vue';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';
import CustomerForm, { CustomerFormModel } from '@/forms/CustomerForm.vue';
import { CustomerApi } from '@/services/CustomerApi';

@Component({
  name: 'edit-customer-modal',
  components: {
    CustomerForm,
    FormSubmit,
    XIcon,
  },
})
export default class EditCustomerModal extends mixins(BaseMixin, FormMixin) {
  @Prop({ required: false, type: Object })
  selectedCustomer!: ICustomer | null;

  model: CustomerFormModel = this.defaultModel();
  deletionImpact: ICustomerDeletionImpact | null = null;
  deletionImpactLoading = false;

  defaultModel(): CustomerFormModel {
    return {
      type: CustomerType.NATURAL,
      status: CustomerStatus.ACTIVE,
      email: '',
      name: '',
      salutation: undefined,
      firstname: '',
      lastname: '',
      additionalName: '',
      profession: '',
      maritalStatus: undefined,
      street: '',
      zip: '',
      city: '',
      addressSupplement: '',
      phoneLandline: '',
      phoneMobile: '',
      identifier: '',
      tags: [],
    };
  }

  @Watch('selectedCustomer', { immediate: true })
  watchSelectedCustomer() {
    if (!this.selectedCustomer) {
      return;
    }
    this.model = {
      id: this.selectedCustomer.id,
      type: this.selectedCustomer.type,
      status: this.selectedCustomer.status,
      email: this.selectedCustomer.email || '',
      name: this.selectedCustomer.name || '',
      salutation: this.selectedCustomer.salutation,
      firstname: this.selectedCustomer.firstname || '',
      lastname: this.selectedCustomer.lastname || '',
      additionalName: this.selectedCustomer.additionalName || '',
      title: this.selectedCustomer.title,
      gender: this.selectedCustomer.gender,
      maritalStatus: this.selectedCustomer.maritalStatus,
      profession: this.selectedCustomer.profession || '',
      street: this.selectedCustomer.street || '',
      zip: this.selectedCustomer.zip || '',
      city: this.selectedCustomer.city || '',
      addressSupplement: this.selectedCustomer.addressSupplement || '',
      phoneLandline: this.selectedCustomer.phoneLandline || '',
      phoneMobile: this.selectedCustomer.phoneMobile || '',
      identifier: this.selectedCustomer.identifier || '',
      birthDate: this.selectedCustomer.birthDate,
      contactPerson: this.selectedCustomer.contactPerson || '',
      user: this.selectedCustomer.user,
      tags: this.selectedCustomer.tags || [],
    };
    this.errors = {};
  }

  get displayName(): string {
    if (this.model.type === CustomerType.LEGAL) {
      return this.model.name || 'Kunde';
    }
    return [this.model.firstname, this.model.lastname].filter(Boolean).join(' ') || 'Kunde';
  }

  /** Zeilenliste für das Lösch-Bestätigungsmodal. */
  get deletionImpactLines(): string[] {
    if (!this.deletionImpact) {
      return [];
    }

    const lines: Array<string | null> = [
      this.formatDeletionCount(
        this.deletionImpact.anbahnungen,
        'Anbahnung',
        'Anbahnungen',
      ),
      this.formatDeletionCount(this.deletionImpact.antraege, 'Antrag', 'Anträge'),
      this.formatDeletionCount(this.deletionImpact.damages, 'Schaden', 'Schäden'),
      this.formatDeletionCount(this.deletionImpact.tasks, 'Aufgabe', 'Aufgaben'),
      this.formatDeletionCount(this.deletionImpact.comments, 'Kommentar', 'Kommentare'),
    ];

    return lines.filter((line): line is string => !!line);
  }

  get hasDeletionAttachments(): boolean {
    return this.deletionImpactLines.length > 0;
  }

  /** Formatiert einen Zähler für die Löschbestätigung (Singular/Plural). */
  formatDeletionCount(count: number, singular: string, plural: string): string | null {
    if (count <= 0) {
      return null;
    }
    return count === 1 ? `1 ${singular}` : `${count} ${plural}`;
  }

  /** Validiert Pflichtfelder je nach Kundentyp. */
  validateModel(): boolean {
    if (this.model.type === CustomerType.LEGAL && !this.model.name?.trim()) {
      this.addError(true, 'name', 'Bitte geben Sie einen Firmennamen an');
      return false;
    }
    if (this.model.type === CustomerType.NATURAL) {
      let valid = true;
      if (!this.model.firstname?.trim()) {
        this.addError(true, 'firstname', 'Bitte geben Sie einen Vornamen an');
        valid = false;
      }
      if (!this.model.lastname?.trim()) {
        this.addError(true, 'lastname', 'Bitte geben Sie einen Nachnamen an');
        valid = false;
      }
      return valid;
    }
    return true;
  }

  async ok(evt: Event) {
    if (!this.model.id) {
      return;
    }
    evt.preventDefault();

    try {
      this.isLoading = true;
      this.resetErrors();

      if (!this.validateModel()) {
        return;
      }

      await CustomerApi.update({
        id: this.model.id,
        agency: this.agency,
        type: this.model.type,
        status: this.model.status,
        email: this.model.email,
        name: this.model.name,
        salutation: this.model.salutation,
        firstname: this.model.firstname,
        lastname: this.model.lastname,
        additionalName: this.model.additionalName,
        title: this.model.title,
        gender: this.model.gender,
        maritalStatus: this.model.maritalStatus,
        profession: this.model.profession,
        street: this.model.street,
        zip: this.model.zip,
        city: this.model.city,
        addressSupplement: this.model.addressSupplement,
        phoneLandline: this.model.phoneLandline,
        phoneMobile: this.model.phoneMobile,
        identifier: this.model.identifier,
        birthDate:
          this.model.type === CustomerType.NATURAL ? this.model.birthDate : undefined,
        contactPerson:
          this.model.type === CustomerType.LEGAL
            ? this.model.contactPerson?.trim() || undefined
            : undefined,
        userId: this.model.user?.id ?? null,
        tags: this.model.tags || [],
      });

      this.$toastr.s(`${this.displayName} erfolgreich bearbeitet.`, 'Kunde bearbeitet');
      this.$emit('reload');
      this.$emit('update-customer');
      this.$nextTick(() => {
        (this.$refs['edit-customer'] as BModal).hide();
      });
    } catch (e) {
      console.log(e);
      this.$toastr.e('Beim Speichern des Kunden ist etwas schief gelaufen.', 'Oops');
    } finally {
      this.isLoading = false;
    }
  }

  cancel() {
    this.errors = {};
  }

  /** Lädt die Anzahl verknüpfter Datensätze beim Öffnen des Löschdialogs. */
  async loadDeletionImpact() {
    if (!this.model.id) {
      this.deletionImpact = null;
      return;
    }

    this.deletionImpactLoading = true;
    this.deletionImpact = null;

    try {
      const response = await CustomerApi.getDeletionImpact({
        id: this.model.id,
        agency: this.agency,
      });
      this.deletionImpact = response.data;
    } catch (e) {
      console.log(e);
      this.$toastr.e('Verknüpfte Datensätze konnten nicht ermittelt werden.');
    } finally {
      this.deletionImpactLoading = false;
    }
  }

  resetDeletionImpact() {
    this.deletionImpact = null;
    this.deletionImpactLoading = false;
  }

  /** Löscht den Kunden nach Bestätigung im Dialog. */
  async confirmDeletion() {
    if (!this.model.id) {
      return;
    }
    try {
      await CustomerApi.delete({
        id: this.model.id,
        agency: this.agency,
      });

      this.$bvModal.hide('modal-delete-customer');
      (this.$refs['edit-customer'] as BModal).hide();
      this.$emit('reload');
      this.$emit('delete-customer');
      this.$toastr.s(`${this.displayName} erfolgreich gelöscht.`, 'Kunde gelöscht');
    } catch (e) {
      console.log(e);
      this.$toastr.e('Beim Löschen des Kunden ist etwas schief gelaufen.');
    }
  }
}
